import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import BenefitsSection from './components/BenefitsSection';
import TrustSection from './components/TrustSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

const SplashPage = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/teacher-login');
  };

  const handleLogin = () => {
    navigate('/teacher-login');
  };

  const handleStudentLogin = () => {
    navigate('/student-login');
  };

  const handleLearnMore = () => {
    console.log('Learn more clicked - Demo video would play');
  };

  const handleContactSupport = () => {
    console.log('Contact support clicked - Support form would open');
  };

  return (
    <div className="min-h-screen bg-background">
      <HeroSection onGetStarted={handleGetStarted} onLogin={handleLogin} onStudentLogin={handleStudentLogin} />
      <FeaturesSection />
      <BenefitsSection />
      <TrustSection />
      <CTASection onGetStarted={handleGetStarted} onLearnMore={handleLearnMore} />
      <FooterSection onContactSupport={handleContactSupport} />
    </div>
  );
};

export default SplashPage;